<!-- 此 component 用來 Edit 檔案頁面 -->
<template>
	<section style="margin: 0px auto; margin-top: 70px" v-loading="!show">
		<el-col :span="12" class="edit-table" v-show="show">
			<el-form :inline="false">
				<el-form-item>
					<div class="edit-title">標題</div>
					<input class="edit-title-input" v-model="fileName" placeholder="填入標題" v-on:keydown.enter.prevent='prevent'>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item>
					<div class="edit-brief-title">簡介（建議200字以內）</div>
					<textarea class="edit-brief-input" v-model="description" placeholder="輸入文字"></textarea>
				</el-form-item>
			</el-form>
		
			<div class="filter-table">	
				<div class="filter-slot" style="margin-right:10px">	
					<div class="edit-filter-title">主題分類</div>
					<el-select v-model="filter.classify.selected" placeholder="" class="filter-select" @change="classifySelect">
						<el-option v-for="selectedFilter in filter.classify.selectedFilters" 
												:key="selectedFilter.value" 
												:label="selectedFilter.text" 
												:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
			  	</div>
				<div class="filter-slot">
					<div class="edit-filter-title">作者</div>
					<el-form v-if="show" :inline="false">
						<autocomplete 
						v-loading="authorLoading"
						ref="autocomplete"
						placeholder="可輸入作者或帳號…"
						:source="accounts"
						input-class="input-author"
						:results-display="formattedDisplay"
						:initial-value="author"
						:initial-display="author"
						results-property="data"
						@selected="addAuthor"
						@clear="clearAuthor"
						v-on:keypress.native="autompletePrevent"
						>
						</autocomplete>
					</el-form>
				</div>
		  	</div>

		 	<div class="filter-table">
				<div class="filter-slot" style="margin-right:10px">	
			   	<div class="edit-filter-title">可閱覽單位</div>
			      <el-select v-model="filter.secret.selected" placeholder="" class="filter-select" @change="secretSelect">
			        <el-option v-for="selectedFilter in filter.secret.selectedFilters" 
			                    :key="selectedFilter.value" 
			                    :label="selectedFilter.text" 
			                    :value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
			      </el-select>
			  	</div>
				<div class="filter-slot">	
					<div class="edit-filter-title">適合程度</div>
					<el-select  v-model="filter.level.selected" placeholder="" class="filter-select" @change="levelSelect">
						<el-option v-for="selectedFilter in filter.level.selectedFilters" 
													:key="selectedFilter.value" 
													:label="selectedFilter.text" 
													:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
				</div>
			</div>

			<div class="input-table">	
				<el-form :inline="false" style="width:100%">
					<div class="edit-keyword-title">關鍵字</div>
					<input-tag ref="keyword" 
										:tags.sync="$store.state.editResource.keywords" 
										placeholder="填入關鍵字…" 
										v-on:keypress.native="prevent">
					</input-tag>
				</el-form>
			</div>

			<el-form :inline="false">
				<div class="edit-file">檔案上傳</div>
				<input v-show="false" type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
				<el-button class="upload-btn" @click="uploadFile">選取檔案
					<img src="../../assets/icon/ic_upload.png" alt="U" class="upload-icon">
					<!--<img v-show="hoverUploadBtn" src="../../assets/icon/ic_upload_hover.png" alt="U" class="upload-icon">-->
				</el-button>
				<div v-for="(attr, index) in this.$store.state.editResourceFileAttrs" :key="index" v-bind:id="'file-' + index">
					<div class="attrs-btn"> 
						<div class="attrs-title"> {{attr.name}} </div>
						<div class="loading-area">
							<!--<div v-bind:id="'progress-' + index" class="progress-title"> {{progress[index] + '%'}} </div>-->
							<circle2 v-bind:id="'circle-' + index"	 
											 class="attrs-uploading-icon">
							</circle2>
						</div>
						<img v-bind:id="'close-' + index"
						     src="../../assets/icon/ic_clear.png" 
								 alt="C" 
								 class="attrs-clear-icon" 
								 @click="deleteFile($store.state.tempEditResourceFileAttrsIds[index])">
					</div>
				</div>
			</el-form>
		</el-col>

		<hint v-show="hint.display && this.$store.state.hintStatus.edit" :message="hint.message" @close="closeHint"></hint>

	</section>
</template>

<script>
  import API from '../../api/api';
	export default {
		data: function ()  {
			return {
				show: false,
				infoId: '',
				fileName: '',
				author: '',
				description: '',
				accounts: [],
				filter: {
					classify: {
						selectedFilters: [],
						selected: 0,
					},
					level: {
						selectedFilters: [],
						selected: 0,
					},
					secret: {
						selectedFilters: [],
						selected: 0,
					}
				},
				//跳出hint
				hint: {
					message: '',
					display: false,
				},
      	//hoverUploadBtn : false,
				files: [],
				timer: null,
				checkUpSliceNum: [],
				checkUploadFail: [],
				progress: [],
				sliceDataInfo: {},
				depLoading: false,
				authorLoading: false,
			}
		},
		watch: {
    	fileName: function(val, oldVal) {
    		this.$store.state.editResource.title = val;
      },
      description: function(val, oldVal) {
    		this.$store.state.editResource.description = val;
			}
    },
		beforeCreate() {
			//avoid dragover and drop
			window.addEventListener("dragover",function(e){
			  e = e || event;
			  e.preventDefault();
			}, false);

			window.addEventListener("drop",function(e){
			  e = e || event;
			  e.preventDefault();
			}, false);
		},
		created() {
			let that = this;
			document.onmousedown = function() {
				if(that.$store.state.nowStatus === 2 && that.$refs.keyword) {
					if(that.$refs.keyword.newTag !== "") { 
						that.$refs.keyword.addNew();
					}
				}
			}
			
			this.getCategories();
			this.initial();
		},
		methods: {
			initial: function() {
				this.$store.state.nowStatus = 2;
				this.$store.state.isCheckSave = true;
				this.$store.state.isBtnProcessing = false;
				this.$store.state.isCancelBtnDisabled = false;

				if(!this.$store.state.isBackendMode) {
					this.$router.push({ path: '/table' });
					return;
				}
				this.infoId = Number(location.hash.split('/')[2]);

				let levelFilters = ['Level 1', 'Level 2', 'Level 3', 'Level 4'];
				for(let i = 0 ; i < levelFilters.length ; i++) {
					let dataFilter = {};
					dataFilter.value = i;
					dataFilter.text = levelFilters[i];
					this.filter.level.selectedFilters.push(dataFilter); 
				}

				let secretFilters = ['所有單位', '僅自己部門'];
				for(let i = 0 ; i < secretFilters.length ; i++) {
					let dataFilter = {};
					dataFilter.value = i;
					dataFilter.text = secretFilters[i];
					this.filter.secret.selectedFilters.push(dataFilter); 
				}
			},
			/**
			  * getResourceDetail 取得單一資源
    		* @param  {number}    resoureId                    - 特定資源的ID
			  * @return {object}    result                       - 結果陣列
			  * @return {number}    result.id                    - 資源Id
			  * @return {string}    result.code                  - 資源編碼
			  * @return {string}    result.title                 - 資源標題
			  * @return {string}    result.description           - 資源敘述
			  * @return {object}    result.category              - 資源主題分類
			  * @return {number}    result.category.id           - 資源主題分類Id
			  * @return {string}    result.category.code         - 資源主題分類代碼
			  * @return {string}    result.category.title        - 資源主題分類標題
			  * @return {number}    result.level                 - 資源級別
			  * @return {number}    result.secret                - 資源機密
			  * @return {number}    result.ctime                 - 資源建立時間
			  * @return {string[]}  result.keywords              - 資源關鍵字
			  * @return {object}    result.fileAttrs             - 資源附檔
			  * @return {string}    result.fileAttrs.fileid      - 資源附檔fileid
			  * @return {string}    result.fileAttrs.filename    - 資源附檔
			  * @return {string}    result.fileAttrs.type        - 資源附檔檔案類型
			  * @return {string}    result.fileAttrs.downloadurl - 資源附件下載連結
			  */  
			getResourceDetail(resoureId) {
				API.getResourceDetail(resoureId).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得單一資源失敗!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						//reset
						this.$store.state.editResourceId = [];
						this.$store.state.editResource.fileIds = [];
						this.$store.state.tempEditResourceFileAttrsIds = [];
						this.$store.state.editResource.keywords = [];

						//assign value
						this.$store.state.editResource.title = response.title;
						this.fileName = response.title;
						this.$store.state.editResource.description = response.description;
						this.description = response.description;
						this.$store.state.editResourceId.push(response.id);
						this.infoId = response.id;
						this.tagsArray = response.keywords;
						this.$store.state.editResource.keywords = response.keywords;
						this.$store.state.editResourceFileAttrs = response.fileAttrs;
						this.$store.state.editResource.author = response.author.username;
						if(response.author.username !== '') {
							this.author = response.author.username + ' (' + response.author.displayname + ')';
						}

						//assign multiselect
						for(let i = 0 ; i < this.filter.classify.selectedFilters.length ; i++) {
							if(response.category.title === this.filter.classify.selectedFilters[i].text) {
								this.filter.classify.selected = i;
								this.$store.state.editResource.categoryId = this.filter.classify.selectedFilters[i].id; 
								break;
							}
						}

						this.$store.state.editResource.depId = response.depId;
						this.$store.state.editResource.actual_depid = response.actual_depid;

						//取得當下部門會員清單
						this.getAccounts(this.$store.state.editResource.actual_depid);

						this.filter.level.selected = response.level - 1;
						this.$store.state.editResource.level = response.level;
						this.filter.secret.selected = response.secret;
						this.$store.state.editResource.secret = response.secret;

						for(let j = 0 ; j < response.fileAttrs.length ; j++) {
							this.$store.state.editResource.fileIds.push(response.fileAttrs[j].fileid);
							this.$store.state.tempEditResourceFileAttrsIds.push(response.fileAttrs[j].fileid);
						}

						setTimeout(()=>{
							for(let l = 0 ; l < response.fileAttrs.length ; l++) {
								document.getElementById("circle-" + l).style.display = "none";
								//document.getElementById("progress-" + l).style.display = "none";
								document.getElementById("close-" + l).style.display = "block";
							}
							this.show = true;
        		}, 500);
					}
				});
			},
			/**
			  * getCategories 取得主題分類
			  * @return none
			  */  
			getCategories() {
				API.getCategories().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得 E-learning 分類失敗!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						for(let i = 0 ; i < response.result.length ; i++) {
							let dataFilter = {};
							dataFilter.value = i;
							dataFilter.id = response.result[i].id;
							dataFilter.text = response.result[i].title;
							this.filter.classify.selectedFilters.push(dataFilter); 
						}

						//編輯頁面
						if(this.infoId) {
							this.getResourceDetail(this.infoId);
						} else {
							//新增頁面
							this.checkUpSliceNum = [];
							this.checkUploadFail = [];
							this.progress = [];
							//initial parameters
							this.$store.state.editResource.title = '';
							this.$store.state.editResource.description = '';
							this.$store.state.editResource.categoryId = this.filter.classify.selectedFilters[0].id;
							this.$store.state.editResource.depId = null;
							this.$store.state.editResource.actual_depid = null;
							this.getAccounts(this.$store.state.userActualDepId);
							this.$store.state.editResource.level = 1;
							this.$store.state.editResource.secret = 0;
							this.$store.state.editResource.keywords = [];
							this.$store.state.editResource.fileIds = [];
							this.$store.state.editResource.author = '';
							this.author = '';
							this.$store.state.tempEditResourceFileAttrsIds = [];
							this.show = true;
						}
					}
				});
			},
			/**
			  * getAccounts 取得帳號列表
				* @param  {number}  actual_depid - 真實部門ID
			  * @return none
			  */   
			getAccounts: function(actual_depid)  {
				this.accounts.length = 0;
				this.authorLoading = true;
				API.getAccountList(actual_depid).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得部門會員清單錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						API.getAccountList(actual_depid, null ,response.total).then((response) => {
							if(response.status) {
								redirectLogin(response.data);
								if(!JSON.parse(response.request.response).error_msg) {
									this.showHint('取得部門會員清單錯誤!');
								} else {
									this.showHint(JSON.parse(response.request.response).error_msg);	
								}
							} else {
								for(let i = 0 ; i < response.result.length ; i++) {
									if(response.result[i].status === 1) {
										let obj = {};
										obj = response.result[i];
										obj.id = i+1;
										this.accounts.push(obj);
									}
								}
								this.authorLoading = false;
							}
						});
					}
				});
			},
			classifySelect: function(key) {
				this.$store.state.editResource.categoryId = this.filter.classify.selectedFilters[key].id;
			},
			levelSelect: function(key) {
				this.$store.state.editResource.level = key + 1;
			},
			secretSelect: function(key) {
				this.$store.state.editResource.secret = key;
			},
			autompletePrevent: function(e) {
				if(e.keyCode === 13) {
					e.preventDefault();
					if(!this.$refs.autocomplete.selectedIndex) {
						this.$refs.autocomplete.selectedIndex = 0;
					} 
				}
			},
			prevent: function(e) {
				if(e.keyCode === 13) {
					e.preventDefault();
				}
			},
			uploadFile: function() {
				this.$refs.files.click();
			},
			deleteFile: function(fileId) {
				let isDeleteOk = true;
				for(let j = 0 ; j < this.$store.state.editResourceFileAttrs.length ; j++) {
					if(document.getElementById("circle-" + j).style.display !== "none") {
						isDeleteOk = false;
					}
				}

				if(!isDeleteOk) {
					this.showHint('其他檔案仍在進行上傳，請稍等上傳完再動作');	
					return;
				}

				this.$confirm('此刪除動作為立即執行，且執行後主題編輯無法取消，是否繼續?', '注意', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//delete true file
					API.deleteResourceFromJustup(fileId).then((result) => {
						if(result.status) {
							redirectLogin(result.data);
							if(!JSON.parse(result.request.response).error_msg) {
								this.showHint('刪除檔案失敗!');	
							} else {
								this.showHint(JSON.parse(result.request.response).error_msg);		
							}
							// delete not exist file
							if(JSON.parse(result.request.response).error_code !== 30000) {
								return;
							}
						} else {
							this.showHint('刪除檔案成功!');					
						}

						for(let j = 0 ; j < this.$store.state.editResource.fileIds.length ; j++) {
							if(this.$store.state.editResource.fileIds[j] === fileId) {
								this.$store.state.editResource.fileIds.splice(j, 1);
								this.$store.state.editResourceFileAttrs.splice(j, 1);
							}
						}	
						
						this.$store.state.tempEditResourceFileAttrsIds = [];
						for(let i = 0 ; i < this.$store.state.editResource.fileIds.length ; i++) {
							this.$store.state.tempEditResourceFileAttrsIds.push(this.$store.state.editResource.fileIds[i]);
						}
						console.log(this.$store.state.editResourceId[0]);
						if(this.$store.state.editResourceId[0]) {
							this.$store.state.isCancelBtnDisabled = true;
						}
					});
				}).catch(() => {
					this.showHint('已取消刪除!');    
				});
			},
			handleFilesUpload: function() {
				this.files= [];
				let uploadedFiles = this.$refs.files.files;
				/*
					Adds the uploaded file to the files array
				*/
				for( var i = 0; i < uploadedFiles.length; i++ ) {
					this.files.push( uploadedFiles[i] );
				}
				this.$refs.files.value = '';

				if(this.files.length > 0) { 
					this.submitFiles();
				}
			},
			submitFiles: function() {
				this.$store.state.isCheckSave = false;
				this.$store.state.tempEditResourceFileAttrsIds.push(null);
				this.$store.state.editResource.fileIds.push(null);

				//取得資源上傳參數
				API.getResourceUploadVariable().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得資源上傳參數失敗!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {

						let index = this.$store.state.editResourceFileAttrs.length;

						for(let j = 0;  j < this.files.length; j++ ) {
							this.checkUpSliceNum[index + j] = 0;
							this.checkUploadFail[index + j] = false;
							this.progress[index + j] = 0;
						}

						for(let i = 0; i < this.files.length; i++ ) {
							let file = this.files[i];
							if(file.size >= this.$store.state.fileChunkSize) {
								//大檔分片上傳
								this.onUploadLargeFile(file, i + index, response);
							} else {
								//一般上傳
								this.uploadResourceCall(file, response.folderId, file.size, 1, 1, file.name, null, i + index);
							}
						}
					}
				});
			},
			/**
 				* [dataSlice 分片上傳前置動作：切割檔案]
 				* @param {[object]} file [上傳的檔案資訊]
				* @return none
				*/
			async onUploadLargeFile(file, index, response, progressbarName) {
				if (!file) return false;

				let chunkCount = Math.ceil(file.size / this.$store.state.fileChunkSize);
				let uuid = this.generateUUID();

				this.sliceDataInfo[index] = [];

				// 開始依chunk上傳， 直到完成
      	for (let i = 0; i < chunkCount; i++) {
        	let result = await this.sliceFile(
          	file,
						chunkCount,
						index,
						i,
						response.folderId,
						uuid,
          	progressbarName
        	);

       	 	// 上傳失敗
         	if (!result) {
						return false;
					}

        	// 計算進度
					/*
					this.progressbars[progressbarName] = (
          	((i + 1) / chunkCount) *
          	100
					).toFixed(2);
					*/
      	}
			},
			async sliceFile(file, chunkCount, counter, index, folderId, uuid, progressbarName) {

				let blob, lowBound = index * this.$store.state.fileChunkSize;

				if(index < chunkCount) {
					blob = file.slice(lowBound, lowBound + this.$store.state.fileChunkSize);
					this.sliceDataInfo[counter].push({
						'chunkNumber': index,
						'chunkFile': blob
					});
			  } else {
					blob = file.slice(lowBound, file.size);
					this.sliceDataInfo[counter].push({
						'chunkNumber': chunkCount,
						'chunkFile': blob
					});
				}

				let sFile = (this.sliceDataInfo[counter]) ? this.sliceDataInfo[counter][index].chunkFile : file;
      	const resData = await this.uploadResourceCall(sFile, folderId, file.size, index + 1, chunkCount, file.name, uuid, counter);

      	if (!resData) return false;
				
      	return true;
    	},
			async uploadResourceCall (file, folderId, size, chunkNumber, chunkTotal, name, uuid, counter) {
				if(!file.name) {
					file.name = name;
				}
			
				if(chunkNumber === 1) {
					this.$store.state.editResourceFileAttrs.push(file);
				}
				
				const resData = await API.addResourceToJustup(file, folderId, name, size, chunkNumber, chunkTotal, uuid).then((result) => {
					if(!result) {
						document.getElementById("file-" + counter).style.display = "none";
						document.getElementById("circle-" + counter).style.display = "none";
						this.showHint('上傳 ' + file.name + ' 失敗');
						this.checkUpSliceNum[counter]++;
						this.progress[counter] = 0;
						this.checkUploadFail[counter] = true;
						return false;
					} else {
						if(result.status && result.status !== 9) {
							if(!JSON.parse(result.request.response).error_msg) {
								this.showHint('上傳 ' + file.name + ' 失敗');
							} else {
								this.showHint(JSON.parse(result.request.response).error_msg);	
							}
							document.getElementById("file-" + counter).style.display = "none";
							document.getElementById("circle-" + counter).style.display = "none";
							this.checkUpSliceNum[counter]++;
							this.progress[counter] = 0;
							this.checkUploadFail[counter] = true;
							return false;
						} else {
							this.checkUpSliceNum[counter]++;
							this.progress[counter] = (((chunkNumber) / chunkTotal) * 100).toFixed(2);
							//show close btn
							if(this.checkUpSliceNum[counter] === chunkTotal && !this.checkUploadFail[counter]) {
								document.getElementById("circle-" + counter).style.display = "none";
								//document.getElementById("progress-" + counter).style.display = "none";
								document.getElementById("close-" + counter).style.display = "block";
								this.$store.state.editResource.fileIds[counter] = result.fileId;
								this.$store.state.tempEditResourceFileAttrsIds[counter] = result.fileId;
							}
						}
					}
					return true;
				});

				//代表可以開放儲存檔案
				let isCheckSave = true;
				for(let i = 0 ; i < this.$store.state.editResourceFileAttrs.length ; i++) {
					if(!this.$store.state.editResource.fileIds[i]) {
						isCheckSave = false;
					}
				}

				if(isCheckSave && this.$store.state.editResource.fileIds.length > 0) {		
					this.$store.state.isCheckSave = true;
				}
		
				return resData;
			},
			addAuthor (author) {
				this.author = author.display;
				this.$store.state.editResource.author = author.selectedObject.name;
			},
			clearAuthor() {
				this.author = '';
				this.$store.state.editResource.author = '';
			},
			formattedDisplay (result) {
				if(result.user) {
					return result.user.username + ' (' + result.user.displayname + ')';
				} else {
					return result.username;
				}
			},
      /*
      /**
			  * closeHint close hint 視窗
			  * @return none
			  */
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.edit = false;
				clearTimeout(this.timer);
			},
			/**
			  * showHint 
			  * @param  {string} message - message
			  * @return none
			  */
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.edit = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.edit = false;
					}
				}, this.$store.state.fadeOutTime);
			},
			generateUUID: function() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					let r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
					return v.toString(16);
				});
			},
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss">
$font-color: #222222;
$tag-color: #626874;
$border-color: #2E90F4;
$background-color: #F5F5F5;
$white-color: #ffffff;

.edit-table {
	position: relative;
	left:25%;
	.edit-title {
		color: $font-color;
		font-size: 16px;
		line-height: 24px;
		font-weight: 700;
	}
	.edit-title-input {
		margin-top: 4px;
		background-color: $white-color;
		border-radius: 2px;
		border: 1px solid #EEE;
		height: 48px;
		width: 100%;
		font-size: 16px;
		padding-left: 10px;
	}
	.edit-brief-title {
		color: $font-color;
		font-size: 16px;
		line-height: 24px;	
		font-weight: 700;
	}
	.edit-brief-input {
		margin-top: 4px;
		background-color: $white-color;
		border-radius: 2px;
		border: 1px solid #EEE;
		height: 120px;
		width: 100%;
		font-size: 16px;
		padding-left: 10px;
	}
	.edit-keyword-title {
		color: $font-color;
		font-size: 16px;
		line-height: 24px;	
		font-weight: 700;
		margin-top: 25px;
		margin-bottom: 5px;
	}
	.edit-file {
		color: $font-color;
		font-size: 16px;
		line-height: 24px;	
		font-weight: 700;
		margin-top: 25px;
	}
	.upload-btn {
		float: left;
		color: #222222;
		font-size: 16px;
		height: 48px;
		margin-top: 9px;
		margin-right: 20px;
		width: 134px;
		background: #FFF;
		white-space: normal;
		border: 1px solid #EEE;
		.upload-icon {
			height: 14px;
			width: 14px;
			float: left;
			color: #222222;
		}
	}	
	.upload-btn:hover {
		float: left;
		color: $font-color;
		font-size: 16px;
		height: 48px;
		margin-top: 9px;
		margin-right: 20px;
		width: 134px;
		background-color: #e5e5e5;
		.upload-icon:hover {
			height: 14px;
			width: 14px;
			float: left;
			color: $border-color;
		}
	}	
	.attrs-btn {
		float: left;
		color: #222222;
		font-size: 16px;
		height: 38px;
		width: 100%;
		margin-top: 9px;
		margin-right: 20px;
		background: #F5F5F5;
		border: 1px solid #EEE;
		cursor: default;
		.attrs-title {
			width: 80%;	
			white-space: nowrap;
			overflow : hidden;
			float: left;
			text-overflow : ellipsis;
			text-align: left;
			line-height: 38px;
			padding-left: 10px;
		}
		.loading-area {
			width: 10%;
			float: right;
			.progress-title {	
				line-height: 38px;
				color: rgb(65, 184, 131);
				font-size: 14px;
				float: right;
				display: block;
			}
			.attrs-uploading-icon {
				height: 24px !important;
				width: 24px !important;
				margin-top: 7px;
				margin-right: 4px;
				float: right;
				white-space: nowrap;
				display: block;
			}
		}	
		.attrs-clear-icon {	
			height: 22px;
			width: 22px;
			float: right;
			margin-top: 10px;
			margin-right: 4px;
			cursor: pointer;
			display: none;
			white-space: nowrap;
		}
	}
	.filter-table {
		display: flex;
		justify-content: space-between;
		margin-top: 25px;
		.dep-filter {
		  width: 50%;
			.dep-filter-title {
			  color: $font-color;
			  font-size: 16px;
			  line-height: 24px;	
			  font-weight: 700;
		  }
		  .dep-filter-select {
			  display: block;
			  max-width: 20vw;
			  text-align: center;
			  margin-top: 8px;

			  .el-input__inner {
				  border-color: #EEE;
				  background-color: $white-color;
				  border-radius: 2px;
				  font-size: 16px;
				  color: $font-color;
				  line-height: 24px;
				  margin-top: 9px;	
			  }

			  .el-input__icon {
					width: 40px;
					margin-top: 4px;
					color: $tag-color;
			  }
		
			  .el-input__suffix {
					&:before{
						content: '';
						position: absolute;
						left: 0;
						height: 32px;
						width: 1px;
						background-color: rgba(151, 151, 151, .35);
						margin-top: 7px;
					}
			  }

			  .el-icon-arrow-up {
					&:before {
						color: #a7a7a7;
						content: '\25B2';
					}
			  }
		  }
		}
		.filter-slot {
			display: inline-block;
			flex: 1;
			.edit-filter-title {
				color: $font-color;
				font-size: 16px;
				line-height: 24px;	
				font-weight: 700;
			}
			.filter-select {
				width: 95%;
				text-align: center;

				.el-input__inner {
					border-color: #EEE;
					background-color: $white-color;
					border-radius: 2px;
					font-size: 16px;
					color: $font-color;
					line-height: 24px;
					margin-top: 9px;	
				}

				.el-input__icon {
					width: 40px;
					margin-top: 4px;
					color: $tag-color;
				}
			
				.el-input__suffix {
						&:before{
							content: '';
							position: absolute;
							left: 0;
							height: 32px;
							width: 1px;
							background-color: rgba(151, 151, 151, .35);
							margin-top: 7px;
						}
				}

				.el-icon-arrow-up {
						&:before {
							color: #a7a7a7;
							content: '\25B2';
						}
				}
			}

			.input-author {
				background: #ffffff;
				border-radius: 2px;
				line-height: 26px;
				padding: 4px;
				font-size: 16px;
				color: $tag-color;
			}
			.autocomplete__box {
				border: 1px solid #EEE;
				margin-top: 9px;
				width: 95%;
			}
			.autocomplete__results {
				border: 1px solid #EEE;	
			}
			.input-author:focus {
				outline: none;
			}
		}
	}
	.input-table {
		display: flex;
	  	justify-content: space-between;	
	}
	
	.vue-input-tag-wrapper {
		margin-top: 5px;
		background: #ffffff;
		border: 1px solid #EEE;
		border-radius: 2px;
	}
	.vue-input-tag-wrapper .input-tag {
		background: $background-color;
		border: 1px solid #EEE;
		border-radius: 2px;
		font-size: 16px;
		color: $font-color;
		line-height: 24px;
	}
	.vue-input-tag-wrapper .new-tag {
		font-size: 16px;
		color: $tag-color;
		line-height: 24px;
	}
	.vue-input-tag-wrapper .input-tag .remove {
		color: $tag-color;
		font-weight: 500;
		font-size: 14px;
		margin-left: 15px;
		float: right;
		margin-top: -1px;
	}
}
</style>


// WEBPACK FOOTER //
// Edit.vue?4b82ee4e